import { Injectable } from '@angular/core';
import { HttpService } from './HttpService';
import { Observable } from 'rxjs';
import { IProfileInfo, IChangeAccountModel } from '../models/IMemberInfo';
import { IAssetResponse } from '../models/IAssetResponce';
import { IAsset } from '../models/IAsset';


@Injectable()
export class ProfileService {
    constructor(private http: HttpService) { }

    updateProfile(model: IProfileInfo): Observable<void> {
        return this.http.put(`profile/update`, model);
    }

    updatePassword(model: IChangeAccountModel): Observable<void> {
        return this.http.post(`profile/update-password`, model);
    }

    uploadProfileImage(formData): Observable<IAssetResponse> {
        return this.http.uploadAsset('assets/upload', formData);
    }

    uploadDocument(formData, identity: string): Observable<IAssetResponse> {
        const url = identity !== '' ? `assets/upload-doc?identity=${identity}` : 'assets/upload-doc';
        return this.http.uploadAsset(url, formData);
    }

    getUserAssets(identity: string): Observable<IAsset> {
        const url = identity === '' ? 'profile/assets' : `profile/assets?identity=${identity}`;
        return this.http.get(url);
    }

    removeUserAsset(assetId: any, identity: string): any {
        const url = identity === '' ? `profile/assets/${assetId}` : `profile/assets/${assetId}?identity=${identity}`;
        return this.http.delete(url);
    }


}
